/*
 *   File : verify-digilocker.js
 *   Author : https://evoqins.com
 *   Description : Onboarding step  - Aadhaar Fetch page
 *   Integrations : react-toastify
 *   Version : 1.0.0
 *   Date : 23-09-2022  
*/

import { useEffect, useState } from "react";
import { Modal } from "bootstrap";

// *********** Components ***************//  
import { Icon } from "../../../Component/Icon";
import { PrimaryButton } from "../../../Component/Buttons";
import { AadhaarFetchStatusModal } from "../../../Component/Modal";

// *********** Styles ***************//  
import styles from "../../../Style/Component/login.module.scss";
import Colors from "../../../Style/color.scss";
import { APIService } from "../../../Service";
import { toast } from "react-toastify";
import { _getSignupProgress } from "../../../Helper";

function VerifyDigiLocker(props) {

    const [loading, setLoading] = useState(false);
    const [fetchStatus, setFetchStatus] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (error == true) {
            new Modal(document.querySelector("#aadhaar-fetch-status-modal")).show();
        }
    }, [error]);


    // handling Enter key 
    useEffect(() => {

        const _handleOnEnter = (e) => {
            if (e.key === 'Enter') {
                _handleLinkDigiLocker();
            }
        };

        document.addEventListener('keydown', _handleOnEnter);

        return () => {
            document.removeEventListener('keydown', _handleOnEnter);
        };

    }, []);

    // handle Verify pan
    const _handleLinkDigiLocker = () => {
        let is_valid = true;

        if (is_valid === true) {
            setLoading(true);
            _linkDigiLockerAC();
        }
    };


    // ================================ //
    //============= API CALLS ========= //

    //API - Fetch aadhaar details from DigiLocker
    const _linkDigiLockerAC = (check_status) => {
        let api_version = 2;
        let is_post = false;
        let url = 'kyc/get-aadhaar';
        let data = null;
        let token = sessionStorage.getItem('access_token');

        APIService(is_post, url, data, token, api_version).then((response) => {
            if (response.status_code === 200) {

                if (check_status === true) {
                    if (response.data.status === 'SUCCESSFUL') {
                        toast.dismiss();
                        toast.success("Aadhaar details fetched successfully", { className: "e-toast", });
                        props.handleUpdateCurrentStep(4); // Add bank details step   

                        // Update signup progress  
                        _getSignupProgress();
                    } else if (response.data.status === 'FAILED ') {
                        setError(true);
                    } else {
                        toast.dismiss();
                        toast.error("Aadhaar fetch cancelled", { className: "e-toast", });
                        setLoading(false);
                    }
                } else {

                    if (response.data.redirect_url != null) {
                        const fetch_window = window.open(response.data.redirect_url, "", "width=500,height=500,left=400,top=100");
                        if (fetch_window === null || typeof fetch_window === 'undefined') {
                            toast.dismiss();
                            toast.error("Please enable Pop-up to open fetch window", { className: "e-toast", });
                            return;
                        };

                        let timer = setInterval(function () {
                            if (fetch_window.closed) {
                                clearInterval(timer);
                                let check_status = true;
                                _linkDigiLockerAC(check_status);
                            }
                        }, 1000);

                    } else {
                        if (response.data.status === 'SUCCESSFUL') {
                            toast.dismiss();
                            toast.success("Aadhaar details fetched successfully", { className: "e-toast", });
                            props.handleUpdateCurrentStep(4); // Add bank details step      
                        }
                    }

                }

            } else {
                toast.dismiss();
                toast.error(response.message, { className: "e-toast", });
                setLoading(false);
            };
        });
    };



    return (
        <div className="col-sm-10 col-md-9 col-lg-8 col-xl-7 mx-auto px-md-0">
            <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">


                {
                    fetchStatus ? (
                        <div className={`${styles.e_onboarding_wrapper_digilocker_status} e-border-radius-24`}>
                            <div className="row">
                                <div className="col text-center position-relative">
                                    <div className="justify-content-center align-items-center d-flex flex-column mt-sm-5 pt-sm-5">
                                        <img src={require("../../../Assets/Images/Onboarding/digilocker-status-loader.gif")}
                                            className="img-fluid object-fit-contain"
                                            height={120}
                                            width={150}
                                            alt="digilocker image"
                                            draggable="false" />

                                        <p className="e-text-black e-font-weight-500 e-alt-font-poppins e-font-16-res e-font-20 mt-sm-5 py-sm-5 py-3">
                                            Fetching Details
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                        :
                        (
                            <div className={`${styles.e_onboarding_wrapper_verify_pan} e-border-radius-24`}>
                                <div className="row justify-content-between align-items-center">
                                    <div className="col-md-6 d-none d-md-block">
                                        <img src={require("../../../Assets/Images/Onboarding/digilocker-step-banner.webp")}
                                            className="img-fluid col-10 ms-4"
                                            alt="pan image"
                                            draggable="false" />
                                    </div>
                                    <div className="col-md-6 position-relative gradient-vr-line">
                                        <div className="margin-32px-right no-margin-res">
                                            <Icon icon="arrow-back-left"
                                                className="cursor-pointer mb-4"
                                                size={24}
                                                onClick={() => props.handleBack()} />

                                            <img src={require("../../../Assets/Images/Onboarding/digilocker.webp")}
                                                className="img-fluid object-fit-contain"
                                                height={60}
                                                width={106}
                                                alt="digilocker image"
                                                draggable="false" />


                                            {/* Info message */}
                                            <div className='d-flex align-items-start gap-2 e-bg-cornsilk e-border-radius-16 p-2 mt-4'>
                                                <Icon icon="info"
                                                    size={"1rem"}
                                                    className="mt-1"
                                                    color={Colors.ochre} />
                                                <span className='e-text-ochre e-alt-font-poppins e-font-14 e-font-weight-400 line-height-24px'>
                                                    Sign in to DigiLocker with your account and give your consent,we’ll safely retrieve your details and proofs for you. If you don’t have a DigiLocker account, please sign up first.
                                                </span>
                                            </div>

                                            <PrimaryButton name='Fetch Details'
                                                loading={loading}
                                                disabled={loading}
                                                className={`w-100 padding-12px-tb e-font-14 mt-3`}
                                                onPress={_handleLinkDigiLocker} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                }
            </div>

            {
                error &&
                <AadhaarFetchStatusModal onCloseModal={() => props.handleUpdateCurrentStep()} />
            }
        </div>
    )
}

export default VerifyDigiLocker;